import React, { useContext } from 'react';
import { Context } from 'components/Store';
import { FormikSelect } from 'components/UiKit/FormikFields';
import { irrigationSystems } from '../DataSets';

const IrrigationSystem = () => {
  const [{ isEnableInfoTabEdit }] = useContext(Context);
  return (
    <FormikSelect
      id="irrigationSystem"
      name="irrigationSystem"
      items={irrigationSystems}
      label="Irrigation System"
      disabled={!isEnableInfoTabEdit}
      placeholder="Select irrigation system"
    />
  );
};

export default IrrigationSystem;
